import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import numeral from 'numeral';

import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';
import Button from 'components/Button';
import Input from 'components/Input';

import { URLS } from 'config';

import TermsModal from './Terms';

import './styles.scss';
import containerActions from './actions';

class Signature extends React.Component {
  state = {
    isOpen: true,
    signature: '',
    termsModalOpen: false,
    sendToEmail: false
  }

  componentWillMount() {
    this.props.getSignature();
  }
  inputChangeHandl = (e) => {
    this.setState({ signature: e.target.value });
  }

  modalTermsHandl = () => {
    this.setState(({ termsModalOpen }) => ({
      termsModalOpen: !termsModalOpen
    }));
  }

  backHandl = () => {
    this.props.history.goBack();
  }

  declineAgreement = (e) => {
    e.preventDefault();

    this.props.history.push(URLS.BASE);
  }

  dateTitleFormat = (date = new Date()) => {
    const dayYaer = moment(date).format('D,YYYY');
    const mount = moment(date).format('MMM');

    return `${mount} ${dayYaer}`;
  }

  numberFromat = (number = 0) => number && numeral(number).format('0,0.00')


  acceptSignatureHandl = () => {
    this.props.sendSignature(() => {
      this.props.history.push(URLS.PAYMENT);
    }, this.state.signature, this.state.sendToEmail);
  }

  sendToEmail = () => {
    this.setState(({ sendToEmail }) => ({
      sendToEmail: !sendToEmail
    }), () => {
      if (this.props.email === '' && !this.props.user.email) {
        this.props.toggleEmailHandl();
      }
    });
  }

  downpayment = (dp) => {
    if (dp > 0) {
      return <li className="list-item"> <i className="ion-ios-checkmark-empty" /> Down payment </li>;
    }
    return '';
  }

  render() {
    const { signature } = this.props;
	  return (
  <React.Fragment>
    <Modal isOpen={this.state.isOpen}>
      <div className="page-signature">
        <ModalHeader backHandl={this.backHandl}>
        Approval
        </ModalHeader>
        <p className="signature-logo" />
        <p className="signature-description -center -header">
          {/* Wrond data */}
          27 Roytec Road, Unit 9 <br />
          Woodbridge, ON, L4L 8E3 <br />
          Phone: (289) 459-0131 <br />
          Fax: (289) 459-0130
        </p>
        <p className="signature-date">
        Dated {this.dateTitleFormat(signature.currentlyDate)}
        </p>

        <p className="signature-sep">
          Between
        </p>

        <p className="signature-adress">
          { signature.addres || '2455350 Ontario Inc. o/a Baron Auto Group'}
        </p>

        <p className="signature-sep">
          And
        </p>

        <p className="signature-name">
          { this.props.name || 'Username'}
        </p>

        <p className="signature-description">
        I/We hereby offer to lease from  { signature.addres || '2455350 Ontario Inc. o/a Baron Auto Group'} the following vehicle according t
        o the terms and conditions herein set forth:
        </p>

        <p className="signature-subtitle">
        VEHICLE DESCRIPTION:
        </p>

        <p className="signature-car">
          { signature.vehicle_name || '2010 FORD F150 EX UNDEFINED' }
        </p>

        <ul className="list">
          <li className="list-item">
            <b>
            Vehicle cost:
            </b>
            <span>
            ${this.numberFromat(signature.vehicle_cost) || '12,998.00'}
            </span>
          </li>
          <li className="list-item">
            <b>
            Warranty:
            </b>
            <span>
            ${this.numberFromat(signature.warranty) || '1,500.00'}
            </span>
          </li>
          <li className="list-item">
            <b>
            Cap cost:
            </b>
            <span>
            ${this.numberFromat(signature.cap_cost) || '11,698.00'}
            </span>
          </li>
        </ul>

        <p className="signature-subtitle">
          LEASE TERMS AND CONDITIONS:
        </p>

        <ul className="list">
          <li className="list-item">
            <b>
          Lease term:
            </b>
            <span>
              { signature.lease.term || '36 month'}
            </span>
          </li>
          <li className="list-item">
            <b>
          Lease rate:
            </b>
            <span>
            ${this.numberFromat(signature.lease.rate) || '496.60'}
            </span>
          </li>
          <li className="list-item">
            <b>
            Taxes:
            </b>
            <span>
            ${this.numberFromat(signature.lease.taxes) || '64.56'}
            </span>
          </li>
          <li className="list-item">
            <b>
            Total lease pmt:
            </b>
            <span>
            ${this.numberFromat(signature.lease.payment) || '561.16'}
            </span>
          </li>
          <li className="list-item">
            <b>
            Residual value:
            </b>
            <span>
            ${this.numberFromat(signature.residential_value) || '1.00'}
            </span>
          </li>
        </ul>

        <p className="signature-subtitle">
        DEALER NAME:
          <span>
            {signature.dealer || 'Baron Auto Group'}
          </span>
        </p>
        <ul className="list">
          <li className="list-item">
            <b>
          Due on delivery:
            </b>
            <span>
              {/* Wrong data */}
              ${this.numberFromat(signature.dueOnDelivery) || 'plus plates'}
            </span>
          </li>
          <li className="list-item">
            Includes:
          </li>
          <li className="list-item">
            <i className="ion-ios-checkmark-empty" /> Administration Fee,
          </li>
          <li className="list-item">
            <i className="ion-ios-checkmark-empty" /> Security deposit,
          </li>
          {this.downpayment(signature.downPayment)}

        </ul>

        <p className="singature-valid">
          Offer valid for { signature.valid || '15 days'}
        </p>

        <button className="signature-terms -left" onClick={this.modalTermsHandl}>
        TERMS AND CONDITIONS
        <i className="material-icons">keyboard_arrow_right</i>
        </button>


        <p className="signature-description">
        The undersigned, being the Lessee or an authorized representative of the Le
        ssee, hereby asknowledges and agrees to the terms and conditions as set forth herein:
        </p>

        <p className="signature-subtitle -color -pad-bot">
          LESSOR’S ACCEPTANCE
        </p>

        <div className="signature-sigin">
          <p className="signin-data">
          Date
          <span>
            {moment(signature.offerDate || new Date()).format('D/MM/YYYY')}
          </span>
          </p>
        </div>

        <div className="signature-sigin -normal -pad-top">
          <Input
            placeholder=""
            value="Olga Bender"
          />
          <p className="signature-description -center">
            President
          </p>
        </div>

        <p className="signature-subtitle -color">
        LESSEE ACCEPTANCE
        </p>

        <div className="signature-sigin -normal">
          <p className="signin-data">
          Name
          <span>
            { this.props.name || 'User Name' }
          </span>
          </p>
        </div>

        <div className="signature-sigin -normal">
          <p className="signin-data">
          Date
          <span>
            {moment(signature.offerDate || new Date()).format('D/MM/YYYY')}
          </span>
          </p>
        </div>

        <br />

        <p className="signature-agreement">
          Type your full name and sign the agreement
        </p>

        <Input
          placeholder="Full name"
          value={this.state.signature}
          changeHandl={this.inputChangeHandl}
        />
        <p className="signature-description -center">
          Authorized signature
        </p>
        <Button
          onClick={this.acceptSignatureHandl}
          disabled={this.state.signature === ''}
        >
          Sign and accept agreement
        </Button>
        <a href="#" className="signature-back" onClick={this.declineAgreement}>
          Decline agreement
        </a>

      </div>
    </Modal>
    <TermsModal
      isOpen={this.state.termsModalOpen}
      backHandl={this.modalTermsHandl}
    />
  </React.Fragment>
	  );
  }
}

Signature.defaultProps = {
  signature: {},
  name: ''
};

Signature.propTypes = {
  // eslint-disable-next-line
  history: PropTypes.object,
  name: PropTypes.string,
  // eslint-disable-next-line
  user: PropTypes.object,
  // eslint-disable-next-line
  signature: PropTypes.object,
  getSignature: PropTypes.func.isRequired,
  sendSignature: PropTypes.func.isRequired,
  toggleEmailHandl: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired
};

const mapToStatePerops = state => ({
  // name: state.name.name,
  email: state.email.email,
  user: state.user.user,
  signature: state.signature.signature,
  name: state.signature.name
});

export default connect(mapToStatePerops, containerActions)(Signature);



// WEBPACK FOOTER //
// ./src/pages/Signature/index.js